"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMargin = exports.resetSpectraScale = exports.setSpectraSameTopHandler = exports.setTab = exports.setActiveTab = exports.levelChangeHandler = exports.handelSetActiveTab = exports.zoomOut = exports.handleZoom = exports.setVerticalIndicatorXPosition = exports.handleBrushEnd = exports.handleToggleRealImaginaryVisibility = exports.handleDeleteBaseLineZone = exports.handleAddBaseLineZone = exports.handleChangeSpectrumDisplayMode = exports.setSpectrumsVerticalAlign = exports.activateTool = exports.setSelectedTool = exports.resetSelectedTool = exports.handleResetSelectedTool = void 0;
const uuid_1 = require("@lukeed/uuid");
const immer_1 = require("immer");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const contours_1 = require("../../../data/data2d/Spectrum2D/contours");
const scale_1 = require("../../1d/utilities/scale");
const DimensionLayout_1 = require("../../2d/utilities/DimensionLayout");
const scale_2 = require("../../2d/utilities/scale");
const useActiveSpectrumRangesViewState_1 = require("../../hooks/useActiveSpectrumRangesViewState");
const ToolTypes_1 = require("../../toolbar/ToolTypes");
const GroupByInfoKey_1 = __importDefault(require("../../utility/GroupByInfoKey"));
const getSpectraByNucleus_1 = require("../../utility/getSpectraByNucleus");
const Constants_1 = require("../core/Constants");
const Zoom1DManager_1 = require("../helper/Zoom1DManager");
const ZoomHistoryManager_1 = __importStar(require("../helper/ZoomHistoryManager"));
const getActiveSpectra_1 = require("../helper/getActiveSpectra");
const getActiveSpectrum_1 = require("../helper/getActiveSpectrum");
const getVerticalAlign_1 = require("../helper/getVerticalAlign");
const DomainActions_1 = require("./DomainActions");
const FiltersActions_1 = require("./FiltersActions");
const PreferencesActions_1 = require("./PreferencesActions");
function resetTool(draft, options = {}) {
    const { resetToDefaultTool = true, resetFiltersOptionPanel = true, defaultToolId = 'zoom', resetSpectrum = false, } = options;
    // reset temp range
    if (resetFiltersOptionPanel) {
        draft.toolOptions.selectedOptionPanel = null;
    }
    if (resetToDefaultTool) {
        draft.toolOptions.selectedTool = defaultToolId;
    }
    if ((draft.toolOptions.data.activeFilterID || draft.tempData) &&
        resetSpectrum) {
        (0, FiltersActions_1.rollbackSpectrumByFilter)(draft, { reset: true });
    }
}
function handleResetSelectedTool(draft) {
    resetSelectedTool(draft);
}
exports.handleResetSelectedTool = handleResetSelectedTool;
function resetSelectedTool(draft, filterOnly = false) {
    if ((draft.toolOptions.selectedTool &&
        ToolTypes_1.options[draft.toolOptions.selectedTool].isFilter) ||
        !filterOnly) {
        resetTool(draft, { resetSpectrum: true });
    }
}
exports.resetSelectedTool = resetSelectedTool;
//utility
function activateTool(draft, options) {
    const { toolId, reset = false } = options;
    if (draft?.data.length > 0) {
        if (toolId) {
            // start Range edit mode
            if (toolId === ToolTypes_1.options.editRange.id) {
                const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
                if (activeSpectrum) {
                    const range = draft.view.ranges?.[activeSpectrum?.id];
                    if (range) {
                        range.showMultiplicityTrees = true;
                    }
                    else {
                        draft.view.ranges[activeSpectrum.id] = {
                            ...useActiveSpectrumRangesViewState_1.defaultRangesViewState,
                            showMultiplicityTrees: true,
                        };
                    }
                }
            }
            if (toolId !== draft.toolOptions.selectedTool) {
                resetTool(draft, { resetToDefaultTool: false });
            }
            draft.toolOptions.selectedTool = toolId;
            if (ToolTypes_1.options[toolId]?.hasOptionPanel) {
                draft.toolOptions.selectedOptionPanel = toolId;
            }
            if (ToolTypes_1.options?.[toolId]?.isFilter) {
                (0, FiltersActions_1.rollbackSpectrum)(draft, { filterKey: toolId, reset });
            }
        }
        else {
            resetTool(draft, { resetToDefaultTool: false });
        }
        setMargin(draft);
    }
}
exports.activateTool = activateTool;
function setSelectedTool(draft, action) {
    const { selectedTool } = action.payload;
    activateTool(draft, { toolId: selectedTool });
}
exports.setSelectedTool = setSelectedTool;
//utility
function getSpectrumID(draft, index) {
    const { activeSpectra, activeTab } = draft.view.spectra;
    const spectra = activeSpectra[activeTab.split(',')[index]];
    if (spectra?.length === 1) {
        return spectra[0].id;
    }
    return null;
}
function setSpectrumsVerticalAlign(draft) {
    const currentVerticalAlign = (0, getVerticalAlign_1.getVerticalAlign)(draft);
    const verticalAlign = ['stack', 'bottom'].includes(currentVerticalAlign)
        ? 'center'
        : 'bottom';
    (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, { verticalAlign });
}
exports.setSpectrumsVerticalAlign = setSpectrumsVerticalAlign;
function handleChangeSpectrumDisplayMode(draft) {
    const currentVerticalAlign = (0, getVerticalAlign_1.getVerticalAlign)(draft);
    const verticalAlign = currentVerticalAlign === 'stack' ? 'bottom' : 'stack';
    (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, { verticalAlign });
}
exports.handleChangeSpectrumDisplayMode = handleChangeSpectrumDisplayMode;
function handleAddBaseLineZone(draft, action) {
    const scaleX = (0, scale_1.getXScale)(draft);
    const { startX, endX } = action.payload;
    const start = scaleX.invert(startX);
    const end = scaleX.invert(endX);
    let zone = [];
    if (start > end) {
        zone = [end, start];
    }
    else {
        zone = [start, end];
    }
    const zones = draft.toolOptions.data.baselineCorrection.zones;
    zones.push({
        id: (0, uuid_1.v4)(),
        from: zone[0],
        to: zone[1],
    });
    draft.toolOptions.data.baselineCorrection.zones = zones.slice();
    (0, FiltersActions_1.calculateBaseLineCorrection)(draft);
}
exports.handleAddBaseLineZone = handleAddBaseLineZone;
function handleDeleteBaseLineZone(draft, action) {
    const { id } = action.payload;
    const state = (0, immer_1.original)(draft);
    draft.toolOptions.data.baselineCorrection.zones =
        state.toolOptions.data.baselineCorrection.zones.filter((zone) => zone.id !== id);
    (0, FiltersActions_1.calculateBaseLineCorrection)(draft);
}
exports.handleDeleteBaseLineZone = handleDeleteBaseLineZone;
function handleToggleRealImaginaryVisibility(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum != null) {
        const { index } = activeSpectrum;
        const datum = draft.data[index];
        datum.display.isRealSpectrumVisible = !datum.display.isRealSpectrumVisible;
        (0, DomainActions_1.setDomain)(draft);
    }
}
exports.handleToggleRealImaginaryVisibility = handleToggleRealImaginaryVisibility;
function handleBrushEnd(draft, action) {
    const is2D = draft.displayerMode === '2D';
    const { height, margin, yDomain, yDomains, width, xDomains, xDomain, mode } = draft;
    const xScale = (0, scale_1.getXScale)({ width, xDomains, xDomain, mode, margin });
    const verticalAlign = (0, getVerticalAlign_1.getVerticalAlign)(draft);
    const yScale = is2D
        ? (0, scale_2.get2DYScale)(draft)
        : (0, scale_1.getYScale)({ height, margin, yDomain, yDomains, verticalAlign });
    const { startX: _startX, endX: _endX, startY: _startY, endY: _endY, trackID, } = action.payload;
    const startX = xScale.invert(_startX);
    const endX = xScale.invert(_endX);
    const startY = yScale.invert(_startY);
    const endY = yScale.invert(_endY);
    const domainX = startX > endX ? [endX, startX] : [startX, endX];
    const domainY = startY > endY ? [endY, startY] : [startY, endY];
    (0, ZoomHistoryManager_1.addToBrushHistory)(draft, { trackID, xDomain: domainX, yDomain: domainY });
}
exports.handleBrushEnd = handleBrushEnd;
function setVerticalIndicatorXPosition(draft, action) {
    const { position } = action.payload;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum?.id) {
        const scaleX = (0, scale_1.getXScale)(draft);
        const value = scaleX.invert(position);
        const datum = draft.data[activeSpectrum.index];
        const index = (0, ml_spectra_processing_1.xFindClosestIndex)(datum.data.x, value);
        draft.toolOptions.data.pivot = { value, index };
    }
}
exports.setVerticalIndicatorXPosition = setVerticalIndicatorXPosition;
function handleZoom(draft, action) {
    const { event, trackID, selectedTool } = action.payload;
    const { displayerMode, yDomains, integralsYDomains } = draft;
    const activeSpectra = (0, getActiveSpectra_1.getActiveSpectra)(draft);
    if (displayerMode === '2D') {
        const index = trackID === DimensionLayout_1.LAYOUT.TOP_1D ? 0 : trackID === DimensionLayout_1.LAYOUT.LEFT_1D ? 1 : null;
        if (index !== null) {
            const id = getSpectrumID(draft, index);
            if (id) {
                const domain = yDomains[id];
                yDomains[id] = (0, Zoom1DManager_1.wheelZoom)(event, domain);
            }
        }
    }
    else if (activeSpectra && activeSpectra?.length > 0) {
        // rescale the active spectra integrals;
        if (selectedTool === ToolTypes_1.options.integral.id && event.shiftKey) {
            for (const activeSpectrum of activeSpectra) {
                //check if the integrals is visible
                const domain = integralsYDomains?.[activeSpectrum?.id];
                if (domain) {
                    integralsYDomains[activeSpectrum?.id] = (0, Zoom1DManager_1.wheelZoom)(event, domain);
                }
            }
        }
        else {
            // rescale the active spectra
            for (const activeSpectrum of activeSpectra) {
                const domain = yDomains?.[activeSpectrum?.id];
                if (domain) {
                    yDomains[activeSpectrum?.id] = (0, Zoom1DManager_1.wheelZoom)(event, domain);
                }
            }
        }
    }
    else {
        // rescale the spectra
        for (const key of Object.keys(yDomains)) {
            const domain = yDomains[key];
            yDomains[key] = (0, Zoom1DManager_1.wheelZoom)(event, domain);
        }
    }
}
exports.handleZoom = handleZoom;
function zoomOut(draft, action) {
    if (draft?.data.length > 0) {
        const { zoomType, trackID } = action?.payload || {};
        const { xDomain, yDomain } = draft.originDomain;
        const zoomHistory = (0, ZoomHistoryManager_1.default)(draft.zoom.history, draft.view.spectra.activeTab, { xDomain, yDomain });
        if (draft.displayerMode === '1D') {
            switch (zoomType) {
                case Zoom1DManager_1.ZOOM_TYPES.HORIZONTAL: {
                    draft.xDomain = xDomain;
                    zoomHistory.clear();
                    break;
                }
                case Zoom1DManager_1.ZOOM_TYPES.VERTICAL:
                    (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8 });
                    break;
                case Zoom1DManager_1.ZOOM_TYPES.STEP_HORIZONTAL: {
                    const zoomValue = zoomHistory.pop();
                    if (zoomValue) {
                        draft.xDomain = zoomValue.xDomain;
                    }
                    else {
                        (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8 });
                    }
                    break;
                }
                default: {
                    draft.xDomain = xDomain;
                    (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8 });
                    zoomHistory.clear();
                    break;
                }
            }
        }
        else {
            const { xDomain, yDomain, yDomains } = draft.originDomain;
            if (trackID) {
                const zoomValue = zoomHistory.pop();
                draft.xDomain = zoomValue ? zoomValue.xDomain : xDomain;
                draft.yDomain = zoomValue ? zoomValue.yDomain : yDomain;
            }
            else {
                zoomHistory.clear();
                draft.xDomain = xDomain;
                draft.yDomain = yDomain;
                draft.yDomains = yDomains;
            }
        }
    }
}
exports.zoomOut = zoomOut;
//utility
function hasAcceptedSpectrum(draft, index) {
    const { activeTab, activeSpectra } = draft.view.spectra;
    const nuclei = activeTab.split(',');
    const spectra = activeSpectra[nuclei[index]];
    if (spectra?.length === 1) {
        const activeSpectrum = spectra[0];
        return (activeSpectrum?.id &&
            !draft.data[activeSpectrum.index].info.isFid);
    }
    return false;
}
//utility
function setMargin(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    const spectrum = (activeSpectrum?.id && draft.data[activeSpectrum.index]) || null;
    if (draft.displayerMode === '2D' &&
        (draft.toolOptions.selectedTool === ToolTypes_1.options.slicing.id ||
            spectrum?.info.isFid)) {
        draft.margin = Constants_1.MARGIN['2D'];
    }
    else if (draft.displayerMode === '2D') {
        const top = hasAcceptedSpectrum(draft, 0)
            ? Constants_1.MARGIN['2D'].top
            : Constants_1.MARGIN['1D'].top;
        const left = hasAcceptedSpectrum(draft, 1)
            ? Constants_1.MARGIN['2D'].left
            : Constants_1.MARGIN['1D'].left;
        draft.margin = { ...Constants_1.MARGIN['2D'], top, left };
    }
    else if (draft.displayerMode === '1D') {
        draft.margin = Constants_1.MARGIN['1D'];
    }
}
exports.setMargin = setMargin;
//utility
function setDisplayerMode(draft, data) {
    draft.displayerMode =
        data && data.some((d) => d.info.dimension === 2)
            ? '2D'
            : '1D';
}
//utility
function setTabActiveSpectrum(draft, dataGroupByTab) {
    const tabs2D = [];
    const tabActiveSpectrum = {};
    const tabkeys = Object.keys(dataGroupByTab).sort((a, b) => a.split(',').length > b.split(',').length ? -1 : 1);
    for (const tabKey of tabkeys) {
        const data = dataGroupByTab[tabKey];
        const nucleusLength = tabKey.split(',').length;
        if (nucleusLength === 2) {
            tabs2D.push(tabKey);
        }
        if (data.length === 1) {
            const index = draft.data.findIndex((datum) => datum.id === data[0].id);
            tabActiveSpectrum[tabKey] = [{ id: data[0].id, index }];
        }
        else {
            const tabSpectra = dataGroupByTab[tabKey];
            const tabSpectraLength = tabSpectra.length;
            if (tabSpectraLength >= 2) {
                const FTSpectrums = tabSpectra.filter((d) => !d.info.isFid);
                if (FTSpectrums.length > 0 &&
                    (nucleusLength === 2 ||
                        (nucleusLength === 1 && tabSpectraLength !== FTSpectrums.length))) {
                    const index = draft.data.findIndex((datum) => datum.id === FTSpectrums[0].id);
                    tabActiveSpectrum[tabKey] = [{ id: FTSpectrums[0].id, index }];
                }
                else if (tabSpectraLength - FTSpectrums > 0) {
                    const id = tabSpectra[0].id;
                    const index = draft.data.findIndex((datum) => datum.id === id);
                    tabActiveSpectrum[tabKey] = [{ id, index }];
                }
                else {
                    tabActiveSpectrum[tabKey] = null;
                }
            }
            else {
                tabActiveSpectrum[tabKey] = null;
            }
        }
    }
    draft.view.spectra.activeSpectra = tabActiveSpectrum;
    return tabs2D;
}
//utility
function setTab(draft, dataGroupByTab, tab, refresh = false) {
    const groupByTab = Object.keys(dataGroupByTab).sort((a, b) => a.split(',').length > b.split(',').length ? -1 : 1);
    if (JSON.stringify(groupByTab) !==
        JSON.stringify(Object.keys(draft.view.spectra.activeSpectra)) ||
        refresh) {
        const tabs2D = setTabActiveSpectrum(draft, dataGroupByTab);
        if (tabs2D.length > 0 && tab == null) {
            draft.view.spectra.activeTab = tabs2D[0];
        }
        else {
            draft.view.spectra.activeTab = !groupByTab.includes(tab)
                ? groupByTab[0]
                : tab;
        }
    }
    else if (tab) {
        draft.view.spectra.activeTab = tab;
    }
    setDisplayerMode(draft, dataGroupByTab[draft.view.spectra.activeTab]);
    setMargin(draft);
}
exports.setTab = setTab;
//utility
function setActiveTab(draft, options) {
    const { tab = null, refreshActiveTab = false, domainOptions = {}, } = options || {};
    const groupByNucleus = (0, GroupByInfoKey_1.default)('nucleus');
    const dataGroupByNucleus = groupByNucleus(draft.data, true);
    setTab(draft, dataGroupByNucleus, tab, refreshActiveTab);
    resetTool(draft);
    (0, DomainActions_1.setDomain)(draft, domainOptions);
    (0, DomainActions_1.setIntegralsYDomain)(draft, dataGroupByNucleus[draft.view.spectra.activeTab]);
    const zoomHistory = (0, ZoomHistoryManager_1.default)(draft.zoom.history, draft.view.spectra.activeTab);
    const zoomValue = zoomHistory.getLast();
    if (zoomValue) {
        draft.xDomain = zoomValue.xDomain;
        draft.yDomain = zoomValue.yDomain;
    }
    (0, DomainActions_1.setMode)(draft);
}
exports.setActiveTab = setActiveTab;
function handelSetActiveTab(draft, action) {
    const { tab } = action.payload;
    if (tab) {
        setActiveTab(draft, { tab });
    }
}
exports.handelSetActiveTab = handelSetActiveTab;
function levelChangeHandler(draft, action) {
    const { deltaY, shiftKey } = action.payload;
    const { data, view: { spectra: { activeTab }, zoom: { levels }, }, } = draft;
    const activeSpectra = (0, getActiveSpectra_1.getActiveSpectra)(draft) || [];
    const activeSpectraObj = {};
    for (const activeSpectrum of activeSpectra) {
        activeSpectraObj[activeSpectrum.id] = true;
    }
    const spectra = (0, getSpectraByNucleus_1.getSpectraByNucleus)(activeTab, data).filter((spectrum) => spectrum.info.isFt &&
        (activeSpectraObj?.[spectrum.id] || activeSpectra.length === 0));
    try {
        for (const spectrum of spectra) {
            const contourOptions = spectrum.display.contourOptions;
            const zoom = (0, contours_1.contoursManager)(spectrum.id, levels, contourOptions);
            levels[spectrum.id] = zoom.wheel(deltaY, shiftKey);
        }
    }
    catch (error) {
        // TODO: handle error.
        reportError(error);
    }
}
exports.levelChangeHandler = levelChangeHandler;
function setSpectraSameTopHandler(draft) {
    if (draft.displayerMode === '1D') {
        draft.originDomain.shareYDomain = false;
        (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8 });
    }
}
exports.setSpectraSameTopHandler = setSpectraSameTopHandler;
function resetSpectraScale(draft) {
    draft.originDomain.shareYDomain = true;
    draft.yDomains = draft.originDomain.yDomains;
    draft.yDomain = draft.originDomain.yDomain;
    (0, Zoom1DManager_1.setZoom)(draft, { scale: 0.8 });
}
exports.resetSpectraScale = resetSpectraScale;
